import { render, staticRenderFns } from "./authorityApplyHistory.vue?vue&type=template&id=396c34d7&scoped=true"
import script from "./authorityApplyHistory.vue?vue&type=script&lang=js"
export * from "./authorityApplyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c34d7",
  null
  
)

export default component.exports